import { Popover, Text, Tooltip } from '@mantine/core';
import type { MatchSuggestion } from '../../types';
import MatchReasonExplainer from './MatchReasonExplainer';

function summariseReasons(suggestion: MatchSuggestion): string {
  const types = new Set(suggestion.matchReasons.map(r => r.type));
  const labels: string[] = [];
  if (types.has('KNOWN_AFFIX')) labels.push('Prefix/suffix match');
  if (types.has('SUBSTRING_CONTAINMENT')) labels.push('Substring match');
  return labels.join(' + ') || 'Matched';
}

type MatchReasonPopoverProps = {
  suggestion: MatchSuggestion;
};

export default function MatchReasonPopover({ suggestion }: MatchReasonPopoverProps) {
  return (
    <Popover
      width={480}
      position="bottom-start"
      withArrow
      shadow="md"
      withinPortal
      middlewares={{ flip: true, shift: { crossAxis: true, padding: 16 } }}
    >
      <Tooltip label="Click to see why these references matched">
        <Popover.Target>
          <Text
            size="xs"
            c="dimmed"
            td="underline"
            style={{ cursor: 'pointer', textDecorationStyle: 'dotted' }}
          >
            {summariseReasons(suggestion)}
          </Text>
        </Popover.Target>
      </Tooltip>
      <Popover.Dropdown>
        <MatchReasonExplainer suggestion={suggestion} />
      </Popover.Dropdown>
    </Popover>
  );
}
